import React from 'react';
import { Box, Button, Typography } from '@heycater/design-system';
import { BoxProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useFoodProgramCta } from 'static_pages/foodProgram/useFoodProgramCta';
import Container from 'system/components/Container';

const BottomCTA = (props: BoxProps) => {
  const { t } = useTranslation('food_program');
  const ctaHref = useFoodProgramCta();

  return (
    <Box as="section" {...props}>
      <Wrapper py={8} textAlign="center">
        <Container>
          <Typography component="h2" mb={5} fontSize={24} fontWeight={600}>
            {t('bottomCTA.title')}
          </Typography>
          <Box>
            <Button component="a" target="_blank" href={ctaHref} rounded>
              {t('cta')}
            </Button>
          </Box>
        </Container>
      </Wrapper>
    </Box>
  );
};

const Wrapper = styled(Box)`
  background: radial-gradient(
    69.82% 65.59% at 63.96% 44.52%,
    #e2ec97 7.76%,
    #e7f4c3 79.45%
  );
`;

export default BottomCTA;
